import React from "react";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";

import * as Sentry from "@sentry/react";

interface ErrorBoundaryProps {
  isMainScreen?: boolean;
  children: React.ReactNode;
}

interface ErrorBoundaryState {
  hasError: boolean;
  error: any;
  eventId: string | null;
}

class ErrorBoundary extends React.Component<ErrorBoundaryProps, ErrorBoundaryState> {
  constructor(props: ErrorBoundaryProps) {
    super(props);
    this.state = { hasError: false, error: null, eventId: null };
  }

  static getDerivedStateFromError(error: any) {
    const eventId = Sentry.captureException(error);
    return { hasError: true, error, eventId };
  }

  componentDidCatch(error: any, errorInfo: any) {
    console.error("Error caught in boundary:", error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      if (this.props.isMainScreen) {
        return (
          <Dialog open={true} onOpenChange={() => {}}>
            <DialogContent className="bg-brand-dark text-white border-0 max-w-96 sm:max-w-[425px]">
              <DialogHeader>
                <DialogTitle className="text-center">Unexpected Error</DialogTitle>
                <DialogDescription className="text-center">
                  An unexpected error has occurred. Our team has been notified.
                </DialogDescription>
              </DialogHeader>        
              <div className="flex gap-2 items-center font-bold justify-center">
                <button
                  className="bg-brand-green text-white px-2 py-1 rounded-lg"
                  onClick={() => window.location.href = '/'}
                >
                  Return to Home
                </button>
              </div>
              <p className="text-center text-gray-200/70 text-wrap ">
                Error ID: {this.state.eventId}
              </p>
            </DialogContent>
          </Dialog>
        );
      } else {
        return (
          <div className="flex flex-col h-full items-center w-full justify-center">
            <p className="text-center text-gray-200/70 text-wrap ">
              An unexpected error has occurred. Our team has been notified.
            </p>
            <p className="text-center text-gray-200/70 text-wrap break-all">
              Error ID: {this.state.eventId}
            </p>
          </div>
        );
      }
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
